import { initializeIcons } from 'office-ui-fabric-react';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { setDataSource } from './configuration';
import { initializeRuntimeStatic } from './initializeRuntime';
import { IAdapterProvider } from './public/adapter.types';
import { SupportedFeatures } from './public/features.types';

let initializeGenerated = false;

// tslint:disable-next-line: no-any
export function createForeignFeatureInterface(
  featureName: SupportedFeatures,
  getFeatureEntry: () => React.ComponentType
): void {
  if (initializeGenerated) {
    return;
  }
  initializeGenerated = true;

  let initializeExecuted = false;

  if (window.yodafeatures === undefined) {
    window.yodafeatures = { cdnUrl: {} };
  }
  const previousInitialize = window.yodafeatures.initialize;

  function foreignFeatureInitializeRuntime(adapter: IAdapterProvider): void {
    if (initializeExecuted) {
      return;
    }
    initializeExecuted = true;

    // __webpack_public_path__ = window.yodafeatures!.cdnUrl[featureName]
    initializeRuntimeStatic(adapter.runtimeStaticConfig);
    initializeIcons(undefined, { disableWarnings: true });

    if (adapter.dataSources) {
      adapter.dataSources(setDataSource);
    }

    window.yodafeatures![featureName] = (element: Element) => {
      return new Promise((resolve: (value?: any) => void, _reject: (reason?:any) => void) => {
        const Component = getFeatureEntry();
        ReactDOM.render(<Component />, element, () => {
          resolve();
        });
      });
    };

    if (previousInitialize !== undefined) {
      previousInitialize(adapter);
    }
  }
  window.yodafeatures.initialize = foreignFeatureInitializeRuntime;
}
